import "./Description.css";
import { useNavigate } from "react-router-dom";

function Description() {

  const navigate = useNavigate();

  function goRegister() {
    navigate ("/sign-up");
  }



  return (
    <section className="description" id="description">
      <div className="description-block">
        <h2 className="skills__title skills__title_description">
          Как проходит обучение?
        </h2>
        <ol className="description-block__list">
          <li className="description-block__element">
            <h3 className="description-block__element-title">
              Весь материал разбит на небольшие уроки
            </h3>
            <p className="description-block__element-subtitle">
              Теория и практика подаются маленькими порциями. Так вам будет
              легче усваивать новые знания.
            </p>
          </li>
          <li className="description-block__element">
            <h3 className="description-block__element-title">
              Обучение через практику
            </h3>
            <p className="description-block__element-subtitle">
              Всё, что вы узнали, вы тут же начинаете применять на практике. Вы
              сразу видите результаты своего труда.
            </p>
          </li>
          <li className="description-block__element">
            <h3 className="description-block__element-title">
              Нет ограничений по времени
            </h3>
            <p className="description-block__element-subtitle">
              Можно совмещать учёбу с работой и другими делами. Не нужно
              выпрашивать академический отпуск, если пришлось сделать перерыв.
            </p>
          </li>
        </ol>
        <div className="description-block__button-container">
          <button type="button" className="description-block__button" onClick={goRegister}>Начать учиться</button>
          <p className="description-block__label">
            Попробуйте, первые уроки бесплатны.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Description;
